<template>
  <transition name="layer">
    <div class="exchange_account_layer" v-if="isDetailAccount">
      <div class="layer_deco">
        <div class="layer">
          <div class="layer-header">
            <h1>계좌 정보 변경</h1>
          </div>
          <div class="contents">
            <p>변경할 계좌번호 입력 후 [인증] 버튼을 클릭 해주세요.</p>
            <dl>
              <dt>계좌주</dt>
              <dd>
                <span v-if="accountOwnerName">{{ accountOwnerName }}</span>
              </dd>
            </dl>
            <dl>
              <dt>은행선택</dt>
              <dd class="form">
                <custom-selectbox
                  @custom-select="updateBankName"
                  :value="bankSelect"
                  :items="bankNameList"
                  firstItem="은행 선택"
                />
              </dd>
            </dl>
            <dl>
              <dt>계좌번호</dt>
              <dd class="form number">
                <v-input-number v-model="accountNo" @custom-input="updateAccountNo" />
                <v-button @handleClick="handleClick" class="btn04" :disabled="!isAvailableCheckAccount" text="인증" />
              </dd>
              <dd class="msg" :class="msgClass">{{ errorMsg }}</dd>
            </dl>
            <div class="bt">
              <v-button @handleClick="handleClickClose" class="btn02" text="취소" />
              <v-button @handleClick="accountRegist()" class="btn01" text="저장" :disabled="!isStateAccount" />
            </div>
          </div>
          <div class="bt">
            <v-button @handleClick="handleClickClose" class="btn_close2" :textHide="true" text="닫기" />
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import CustomSelectbox from '@/components/atoms/CustomSelectbox';
import VInputNumber from '@/components/atoms/VInputNumber';
import VButton from '@/components/atoms/VButton';
import mixin from '@/utils/mixin';
import _ from 'lodash';

export default {
  mixins: [mixin],
  components: {
    CustomSelectbox,
    VInputNumber,
    VButton,
  },
  data() {
    return {
      accountNo: '',
      accountOwnerName: '',
      errorMsg: '',
      errorCode: '',
      msgClass: '',
      prevAccount: '',
    };
  },
  computed: {
    ...mapGetters('userInfo', ['userInfo']),
    ...mapGetters('exchange', [
      'exchangeList',
      'bankSelect',
      'exchangeDetail',
      'bankNameList',
      'exchangeAccountRequest',
      'isStateAccount',
      'isDetailAccount',
    ]),
    isAvailableCheckAccount() {
      return this.accountNo;
    },
    exchangeDetailCnts() {
      return this.exchangeList.list[this.exchangeDetail];
      // return _.find(this.exchangeList.list, {'exchangeNo': this.exchangeDetail} );
    },
  },
  methods: {
    ...mapActions('exchange', [
      'setBankName',
      'setAccountNo',
      'checkBankAccount',
      'setExchangeDetailAccount',
      'setExchangeAccountState',
      'setExchangeAccountRegist',
    ]),
    updateBankName(val) {
      this.setBankName(val);
      this.checkAccount();
    },
    updateAccountNo(val) {
      this.setAccountNo(val);
      this.checkAccount();
    },
    checkAccount() {
      if (
        this.prevAccount != '' &&
        this.prevAccount.bankCode != this.exchangeAccountRequest.bankCode + this.accountNo
      ) {
        this.msgClass = 'red';
        this.errorMsg = '계좌정보가 변경 되어 다시 인증하셔야 합니다.';
      }
    },
    handleClickClose() {
      this.setExchangeDetailAccount(false);
      this.setExchangeAccountState(false);
      this.accountNo = '';
      this.msgClass = '';
      this.errorMsg = '';
      this.prevAccount = '';
    },
    async handleClick() {
      if (this.bankSelect === -1) {
        this.msgClass = 'red';
        this.errorMsg = '은행을 선택하세요.';
        return;
      }
      if (!this.accountNo) {
        this.msgClass = 'red';
        this.errorMsg = '계좌번호를 입력하세요.';
        return;
      }
      const apiReturn = await this.checkBankAccount({
        businessType: 1,
        bankCode: this.exchangeAccountRequest.bankCode,
        accountNo: this.accountNo,
      });
      this.errorCode = apiReturn.code;
      if (apiReturn.code > 0) {
        this.msgClass = 'red';
        this.errorMsg = '본인 계좌 번호만 입력 가능합니다.';
      } else if (apiReturn.code === 0) {
        this.accountOwnerName = apiReturn.data.accountOwnerName;
        this.msgClass = 'blue';
        this.errorMsg = '본인 계좌 번호로 확인되었습니다.';
        this.prevAccount = this.exchangeAccountRequest.bankCode + this.accountNo;
      }
    },
    async accountRegist() {
      const apiReturn = await this.setExchangeAccountRegist({
        ...this.exchangeAccountRequest,
        exchangeNo: this.exchangeDetailCnts.exchangeNo,
      });
      if (apiReturn.code === 3007) {
        this.openModal({
          type: 'confirm',
          message: '장시간 이용이 없어 인증이 만료되었습니다.<br/>처음부터 다시 진행해주세요.',
          callback: () => {
            this.setExchangeDetailAccount(false);
          },
        });
      }
      this.msgClass = '';
      this.errorMsg = '';
      this.prevAccount = '';
      this.accountNo = '';
    },
  },
};
</script>
